import {Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '../../../common/widgets/general/data-table';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {CommentBdc} from '../../common/services';
import {CommentService} from '../../common/services';
import {DatePipe} from '@angular/common';
import {TruncatePipe} from '@Common/widgets/pipes';

import { MatDialog } from '@angular/material/dialog';
import {CommentModaleComponent} from './comment-modale/comment-modale.component';
import {finalize} from 'rxjs/operators';

import {Subscription} from 'rxjs';
import {FileSaverService} from '@Services/common';
import {PubSubService} from '../../common/services/pub-sub.service';

@Component({
  selector: 'p8-bdc-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];
  dsComs: MatDataSourceGeneric<CommentBdc> = new MatDataSourceGeneric<CommentBdc>();
  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;

  extraParams: Map<string, string> = new Map<string, string>();

  columns: ColumnDataTable[] = [
    { columnDef: 'id', header: 'ID', display: (row: CommentBdc) => {
        return row.id;
      } , sort: true, flex: 4 },
    { columnDef: 'user', header: 'auteur', display: (row: CommentBdc) => {
        if ('first_name' in row.user_obj && 'last_name' in row.user_obj) {
          return `${row.user_obj.first_name} ${row.user_obj.last_name}`;
        }

        return row.user_obj.username;
      } , sort: true, flex: 7, tooltip: (row) => {
        return row.user_obj.email;
      } },

    { columnDef: 'dt_created', header: 'date',
      display: (element) => {
        if (element.dt_created) {
          const dp: DatePipe = new DatePipe(this.locale);
          return dp.transform(`${element.dt_updated}`, 'dd/MM/yyyy - H:mm');
        }

        return '';
      }, sort: true, flex: 12 },

    { columnDef: 'page', header: 'page', display: (row: CommentBdc) => {
        const tr: TruncatePipe = new TruncatePipe();
        return tr.transform(row.page_obj.title, 30);
      } , sort: true, tooltip: (row) => {
        return row.page_obj.title;
      }, flex: 25 },

    { columnDef: 'text', header: 'commentaire', display: (row: CommentBdc) => {
      const tr: TruncatePipe = new TruncatePipe();
      return tr.transform(row.text, 40);
      } , sort: true},
    ];

  actions: ActionDataTable[] = [
    { label: 'Afficher', tooltip: 'Afficher le commentaire complet',  icon: 'remove_red_eye', click: (row) => this.afficher(row),  },
  ];

  constructor(@Inject(LOCALE_ID) private locale: string,
              public dialog: MatDialog,
              private comSvc: CommentService,
              private fileService: FileSaverService,
              private pubSubSvc: PubSubService) {
    this.dsComs.daoService = comSvc;
  }

  ngOnInit() {
  }

  afficher(row) {
    const dialogRef = this.dialog.open(CommentModaleComponent, {
      width: '650px',
      height: '',
      data: row
    });
    dialogRef.updatePosition({top: '80px'});
    dialogRef.afterClosed().subscribe(result => result);
  }

  ExportAllComments() {
    this.pubSubSvc.publish('loading', true);

    this.subs.push(this.comSvc.exporyAllComments()
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_excel) => {
        const filename = `Commentaires`;
        this.fileService.FileSave(_excel, filename, 'xlsx');
      }));
  }
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((_sub) => {
        if (_sub) {
          _sub.unsubscribe();
        }
      });
    }
  }

}
